import { GridColumn } from 'src/components/GridWrapper';
import { BlindReceivePermissions } from 'src/components/guards/PermissionsList';
import usePermission from 'src/hooks/usePermissions';

const usePoLineItemColumns = (isInvoice: boolean) => {
  const isBlindReceive = usePermission({ permissions: BlindReceivePermissions });
  const poLineItemColumns: GridColumn<any>[] = [
    ...(isBlindReceive
      ? []
      : ([
          {
            field: 'poItemQty',
            title: 'PO Qty',
            filter: 'numeric',
            dataType: 'number',
            filterFormat: '#',
            step: 1,
          },
          {
            field: isInvoice ? 'invoiceTtlQty' : 'receiptTtlQty',
            title: isInvoice ? 'Total Qty Invoiced' : 'Total Qty Received',
            filter: 'numeric',
            dataType: 'number',
            filterFormat: '#',
            step: 1,
          },
        ] as GridColumn<any>[])),

    {
      field: 'itemNum',
      title: 'Item #',
      filter: 'text',
      dataType: 'string',
    },
    {
      field: 'description',
      title: 'Description',
      filter: 'text',
      dataType: 'string',
    },
    {
      field: 'glCode',
      title: 'GL Code',
      filter: 'text',
      dataType: 'string',
    },
    {
      field: 'uom',
      title: 'UOM',
      filter: 'text',
      dataType: 'string',
    },
  ];
  return poLineItemColumns;
};

export default usePoLineItemColumns;
